const chicagoTimeZone = "America/Chicago";
/* eslint-disable-next-line */
export default function(isTime, setDate, isChicagoTime) {
	const currentDate = new Date();
	if (isChicagoTime) {
		const chicagoDate = new Date(currentDate.toLocaleString("en-US", { timeZone: chicagoTimeZone }));
		const year = chicagoDate.getFullYear();
		const month = String(chicagoDate.getMonth() + 1).padStart(2, "0");
		const day = String(chicagoDate.getDate()).padStart(2, "0");
		const hours = String(chicagoDate.getHours()).padStart(2, "0");
		const minutes = String(chicagoDate.getMinutes()).padStart(2, "0");

		return `${ year }-${ month }-${ day } ${ hours }:${ minutes }`;
	}

	const formatDate = setDate || currentDate.toISOString().substr(0, 10);
	if (isTime) {
		const hours = currentDate.getHours();
		const minutes = currentDate.getMinutes();

		return `${ formatDate } ${ hours }:${ minutes }`;
	}

	return formatDate;
}
